import { api } from '../api';
import {
  GetMarketSelectorsResponse,
  GetMarketStatusResponse,
  getOtcMarketTickerResponse,
  OtcKlineRequest,
  OtcKlineResponse
} from '../otc/types';
import {
  GET_ASSETS_LIST_SELECTOR,
  GET_ASSETS_PRICE_OTC_TICKER,
  GET_OTC_CHART_DATA,
  GET_OTC_MARKET_STATUS
} from '../../constants/otc';
import {
  GET_DEPOSIT_CRYPTO_TRANSACTIONS,
  GET_DEPOSIT_TOMAN_TRANSACTIONS,
  GET_DISTRIBUTION_HISTORY,
  GET_EXCHANGE_OTC_HISTORY,
  GET_FIAT_OTC_HISTORY,
  GET_NETWORK_LIST,
  GET_P2P_ORDERS_HISTORY,
  GET_WITHDRAW_CRYPTO_TRANSACTIONS,
  GET_WITHDRAW_TOMAN_TRANSACTIONS
} from '../../constants/history';
import {
  CryptoDepositHistoryRequestType,
  CryptoDepositHistoryResponseType,
  CryptoWithdrawHistoryRequestType,
  CryptoWithdrawHistoryResponseType,
  DistributionRequestType,
  DistributionResponseType,
  NetworkListRequestType,
  NetworkListResponseType,
  OtcHistoryRequestType,
  OtcHistoryResponseType,
  P2pOrderP2pHistoryListRequestType,
  P2pOrderP2pHistoryListResponseTypes,
  TomanDepositHistoryRequestType,
  TomanDepositHistoryResponseType,
  TomanWithdrawHistoryResponseType,
  TransactionHistoryRequestType
} from './types';

export const historySlice = api.injectEndpoints({
  endpoints: (build) => ({
    getFiatDepositHistory: build.query<
      TomanDepositHistoryResponseType,
      TomanDepositHistoryRequestType
    >({
      query: (data) => {
        return {
          url: GET_DEPOSIT_TOMAN_TRANSACTIONS,
          method: 'POST',
          body: data
        };
      }
    }),
    getFiatWithdrawHistory: build.query<
      TomanWithdrawHistoryResponseType,
      TransactionHistoryRequestType
    >({
      query: (data) => {
        return {
          url: GET_WITHDRAW_TOMAN_TRANSACTIONS,
          method: 'POST',
          body: data
        };
      }
    }),
    getCryptoDepositHistory: build.query<
      CryptoDepositHistoryResponseType,
      CryptoDepositHistoryRequestType
    >({
      query: (data) => {
        return {
          url: GET_DEPOSIT_CRYPTO_TRANSACTIONS,
          method: 'POST',
          body: data
        };
      }
    }),
    getCryptoWithdrawHistory: build.query<
      CryptoWithdrawHistoryResponseType,
      CryptoWithdrawHistoryRequestType
    >({
      query: (data) => {
        return {
          url: GET_WITHDRAW_CRYPTO_TRANSACTIONS,
          method: 'POST',
          body: data
        };
      }
    }),
    getDistributionHistory: build.query<
      DistributionResponseType,
      DistributionRequestType
    >({
      query: (data) => {
        return {
          url: GET_DISTRIBUTION_HISTORY,
          method: 'POST',
          body: data
        };
      }
    }),
    getFiatOtcHistory: build.query<
      OtcHistoryResponseType,
      OtcHistoryRequestType
    >({
      query: (data) => {
        return {
          url: GET_FIAT_OTC_HISTORY,
          method: 'POST',
          body: data
        };
      }
    }),
    getExchangeOtcHistory: build.query<
      OtcHistoryResponseType,
      OtcHistoryRequestType
    >({
      query: (data) => {
        return {
          url: GET_EXCHANGE_OTC_HISTORY,
          method: 'POST',
          body: data
        };
      }
    }),
    getP2PHistory: build.query<
      P2pOrderP2pHistoryListResponseTypes,
      P2pOrderP2pHistoryListRequestType
    >({
      query: (data) => {
        return {
          url: GET_P2P_ORDERS_HISTORY,
          method: 'POST',
          body: data
        };
      }
    }),
    getNetworkList: build.query<
      NetworkListResponseType,
      NetworkListRequestType
    >({
      query: (data) => {
        return {
          url: GET_NETWORK_LIST,
          method: 'POST',
          body: data
        };
      }
    })
  }),
  overrideExisting: false
});
export const {
  useGetCryptoDepositHistoryQuery,
  useLazyGetCryptoDepositHistoryQuery,
  useGetCryptoWithdrawHistoryQuery,
  useLazyGetCryptoWithdrawHistoryQuery,
  useGetFiatDepositHistoryQuery,
  useLazyGetFiatDepositHistoryQuery,
  useGetFiatWithdrawHistoryQuery,
  useLazyGetFiatWithdrawHistoryQuery,
  useGetDistributionHistoryQuery,
  useLazyGetDistributionHistoryQuery,
  useGetFiatOtcHistoryQuery,
  useLazyGetFiatOtcHistoryQuery,
  useLazyGetExchangeOtcHistoryQuery,
  useGetExchangeOtcHistoryQuery,
  useLazyGetP2PHistoryQuery,
  useGetP2PHistoryQuery,
  useGetNetworkListQuery
} = historySlice;
